import React from "react";
import { humidity } from "../../../icons/humidity";
import { wind_speed } from "../../../icons/wind_speed";
import unknown from '../weather-icons/unknown.png'

function Weather({ data, city }) {
  const images = require.context("../weather-icons", true);
  const weatherIcon = data && images(`./${data?.weather[0].icon}.png`) 

  return (
    <div>
      <img
        // src={`https://openweathermap.org/img/wn/${data?.weather[0].icon}@2x.png`}
        src={data ? weatherIcon : unknown}
        alt=""
        className="mx-auto my-2 "
      />
      <div className=" flex-col flex text-white bg-white/30 rounded-[14px] border-white/40 p-4 border">
        <div className="mx-auto">
          <span className="font-bold italic"> {city ? city : data?.name}</span>
        </div>
        {data ? (
          <div className="mx-auto text-center mb-5 ">
            <div className="font-poppins text-[4rem]  text-3xl  my-6">
              <p
                style={{
                  textShadow: "-2px 5px 34px rgba(0, 0, 0, 0.10)",
                }}
              >
                {Math.round(data?.main.temp)}°
              </p>
            </div>

            <div className="font-bold italic text-center my-1">
              {data?.weather[0].description}
            </div>
          </div>
        ) : (
          <div className="flex relative my-4   flex-col gap-4">
            <div className="bg-[#dddddd] animate-pulse w-[50%] rounded-lg h-[1rem] mx-auto "></div>
            <div className="bg-[#dddddd] animate-pulse w-[50%] rounded-lg h-[1rem] mx-auto "></div>
            <div className="bg-[#dddddd] animate-pulse w-[50%] rounded-lg h-[1rem] mx-auto "></div>
          </div>
        )}

        <div className=" px-1 ">
          <div className="flex justify-evenly">
            <div className="w-20 text-center flex items-center justify-center">
              %{" "}
              {data ? (
                Math.round(data.main.humidity)
              ) : (
                <div className="bg-[#dddddd] animate-pulse rounded-lg w-10 h-4 mx-auto "></div>
              )}
            </div>
            <span>|</span>
            <div className="flex gap-3 w-24 justify-end">
              <span className="">الرطوبة</span>

              <span className="">{humidity}</span>
            </div>
          </div>
          <div className="flex justify-evenly mt-4">
            <div dir="rtl" className="w-20 text-center flex items-center justify-center">
              {data ? (
                Math.round(data?.wind.speed)
              ) : (
                <div className="bg-[#dddddd] animate-pulse rounded-lg w-4 h-4 mx-auto "></div>
              )}
              {"  "}متر/ثانية
            </div>
            <span>|</span>

            <div className="flex gap-3 w-24 justify-end">
              <span>الرياح</span>

              <span className="">{wind_speed}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Weather;
